// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateGuatemalanDocument(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  }
  const eightDigitsRegex = /\d{8}/;
  if (!eightDigitsRegex.test(document)) {
    return { id: 'invalid-ci-pattern' };
  }
}
